export { default } from './ItemResultatDefault';
